module.exports = __webpack_public_path__ + "media/images/brave_icon-d4735b9b41eeb84e6ba522cefbb0976b.png";